import React, { useState } from "react";

const Accordion = ({ title, content, id }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className="faq-accordion" key={id} itemScope itemProp="mainEntity" itemType="https://schema.org/Question">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div itemProp="name">{title}</div>
        <div className={`close-icon ${isActive ? "active-accordion" : ""}`}></div>
      </div>
      <div
        itemScope
        itemProp="acceptedAnswer"
        itemType="https://schema.org/Answer"
        className={`${!isActive ? "accordion-content" : "accordion-content-active"}`}
      >
        {content}
      </div>
    </div>
  );
};

export default Accordion;
